<template>
    <div class="job-item" :id="'job-'+id" :ref="'job-'+id">
        <div class="header">
            <div class="title" @click="toggle()">
                {{data.title}}
            </div>
            <div class="control" v-if="isPermissions('job_edit,job_delete,job_update_status,job_view_candidates')">
                <ui-menu-action>
                    <li v-if="isPermission('job_edit')">
                        <button type="button" @click="modaUpdate()">Editar</button>
                    </li>
                    <li v-if="isPermission('job_delete')">
                        <button type="button" @click="modalRemove()">Excluir</button>
                    </li>
                    <li v-if="isPermission('job_update_status')">
                        <button type="button" @click="modalStatus()">Alterar status</button>
                    </li>
                    <li v-if="isPermission('job_view_candidates')">
                        <button type="button" @click="modalCandidates()">Ver Candidados</button>
                    </li>
                </ui-menu-action>
            </div>
        </div>
        <div class="content">
            <div class="control" v-if="isPermission('job_candidate')">
                <div class="check-job">
                    <input type="checkbox" :value="data.id" :id="'job-'+data.id" v-model="jobsUser" @click="subscriber()">
                    <label :for="'job-'+data.id">
                        <span></span>
                    </label>
                </div>
            </div>
            <div class="section-text" v-if="data.description">
                <h2>Descrição:</h2>
                <div class="text" v-html="data.description"></div>
            </div>
            <div class="section-text" v-if="data.responsibilities">
                <h2>Responsabilidades:</h2>
                <div class="text" v-html="data.responsibilities"></div>
            </div>
            <div class="section-text" v-if="data.requirements">
                <h2>Exigências:</h2>
                <div class="text" v-html="data.requirements"></div>
            </div>
            <div class="section-text" v-if="data.benefits">
                <h2>Benefícios:</h2>
                <ul>
                    <li v-for="(item, index) in benefits" :key="index"><i class="far fa-dot-circle"></i> {{item}}</li>
                </ul>
            </div>
            
            <div class="section-text" v-if="data.regime">
                <h2>Regime de Contratação:</h2>
                <div class="salary">{{data.regime}}</div>
            </div>
            <div class="section-text">
                <h2>Salário:</h2>
                <div class="salary">{{data.salary ? data.salary : 'À combinar'}}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import { uiMenuAction } from '@/components'
    import { jobs, storage } from '@/services'
    import permissions from '@/mixins/permissions'
    export default {
        components: { uiMenuAction },
        mixins: [permissions],
        props: {
            data: {
                type: Object,
                required: true
            },
            index: {},
        },
        computed:{
            id(){
                return this._uid
            },
            benefits(){
                return this.data.benefits.split(',')
            }
        },
        data() {
            return {
                status: false,
                jobsUser: [],
                candidates: [],
            }
        },
        methods: {
            toggle(){
                this.$parent.$emit("job-open", this.id)
            },
            modalRemove(){
                this.$root.$emit('modal', 'remove-job');
                this.$parent.$emit('delete-register', {
                    data: this.data,
                    index: this.index
                });
            },
            modaUpdate(){
                this.$root.$emit('modal', 'add-job');
                this.data.index = this.index
                this.$root.$emit('update-register', this.data);
            },
            modalStatus(){
                this.$root.$emit('modal', 'job-status');
                this.data.index = this.index
                this.$parent.$emit('update-status', this.data);
            },
            modalCandidates(){
                this.$root.$emit('modal', 'candidates-job');
                this.$parent.$emit('get-candidates', this.data)
            },
            subscriber(){
                jobs.setCandidate(this.data.id).then( response => {
                    storage.updateUserData('jobs', response.data)
                    this.getUserJobs()
                })
            },
            getUserJobs(){
                const items = storage.getUser().jobs
                this.jobsUser = items
            },
        },
        created(){
            this.$parent.$on("job-open", (id) => {
                if(id === this.id){
                    let el = this.$refs['job-'+id]
                    if(el.classList.contains('active')){
                        el.classList.remove('active')
                    }else{
                        el.classList.add('active')
                    }
                }
            })
        },
        mounted(){
            this.getUserJobs()
        }
    }
</script>

<style lang="stylus">
    @import 'styles.styl';
</style>    
